import { axiosInstance } from '../utils/helpers';

// Calls to the spaces-platform-integration service, via the same-origin
// /spaces/api/platform/* gateway route shared with the other SysAid clients.
// The account is resolved from the session by the gateway; axiosInstance's baseURL
// is window.location.origin, so the /spaces path resolves correctly.

// Platform-wide identity context (shared with the other SysAid clients).
export function getTrackEventContext() {
  return axiosInstance
    .get('/spaces/api/platform/track_event/context', {
      params: { snakeCaseKeys: true }
    })
    .then((res) => res.data);
}

// Reads the auth0-authentication feature flag. Falls back to false so logout uses the
// legacy path on any error/timeout — servicePortal's default axios timeout is very high,
// so cap this call.
export function getAuth0AuthenticationFlag() {
  return axiosInstance
    .get('/spaces/api/platform/feature_flags/auth0-authentication', {
      params: { defaultValue: false },
      timeout: 10000
    })
    .then((res) => res.data === true)
    .catch(() => false);
}



// WEBPACK FOOTER //
// ./actions/platformIntegration.js